"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogTags = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var LogTags = function LogTags() {
  var storage = {};

  function addTag(tag, value) {
    storage[tag] = value;
  }

  function getTags() {
    return (0, _objectSpread2.default)({}, storage);
  }

  function setTags(tags) {
    storage = tags;
  }

  function updateTags(tags) {
    storage = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, storage), tags);
  }

  function clearTags() {
    storage = {};
  }

  function toString() {
    return JSON.stringify(storage);
  }

  return {
    addTag: addTag,
    clearTags: clearTags,
    setTags: setTags,
    toString: toString,
    updateTags: updateTags,
    getTags: getTags
  };
};

exports.LogTags = LogTags;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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